var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "/" } },
        [
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { path: "/invoice-disputes/index" } } },
            [_vm._v(_vm._s(_vm.$t("invoice-disputes.title")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-card",
                [
                  _c("Filters", { attrs: { "on-filter": _vm.handleFilter } }),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    { attrs: { inline: "" } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "mini",
                                value: _vm.$t("invoice-disputes.assign_to"),
                                placeholder: _vm.$t(
                                  "invoice-disputes.assigned_to"
                                ),
                                disabled: _vm.selectedTasks.length == 0
                              },
                              on: { change: _vm.handleAssignTheLot }
                            },
                            [
                              _c("el-option", {
                                key: "unassigned",
                                attrs: {
                                  label: _vm.$t("invoice-disputes.unassigned"),
                                  value: "unassigned"
                                }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.participantUsers, function(user) {
                                return _c("el-option", {
                                  key: user.person_by_reference.reference,
                                  attrs: {
                                    label: user.person_by_reference.username,
                                    value: user.person_by_reference.reference
                                  }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.$apollo.queries.tasks.loading,
                          expression: "$apollo.queries.tasks.loading"
                        }
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.groupedTasks,
                        "highlight-current-row": ""
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "selection-change": _vm.handleSelectionChange
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "45" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "200",
                          prop: "recipient.name",
                          sortable: "",
                          label: _vm.$t("invoice-disputes.recipient_name")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(scope.row.recipient.name) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "150",
                          prop: "recipient.account_id",
                          sortable: "",
                          label: _vm.$t("invoice-disputes.recipient_account_id")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", { staticClass: "break" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(scope.row.recipient.account_id) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "128",
                          prop: "from",
                          sortable: "",
                          label: _vm.$t("invoice-disputes.start_date")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", { staticClass: "from" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("parseTime")(
                                          scope.row.from,
                                          "{d}-{m}-{y}"
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "128",
                          prop: "until",
                          sortable: "",
                          label: _vm.$t("invoice-disputes.end_date")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", { staticClass: "until" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("parseTime")(
                                          scope.row.until,
                                          "{d}-{m}-{y}"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.isDue(scope.row)
                                    ? _c("span", [_vm._v("•")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isOverdue(scope.row)
                                    ? _c("span", [_vm._v("•")])
                                    : _vm._e()
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "140",
                          prop: "invoice_disputes.length",
                          sortable: "",
                          label: _vm.$t("invoice-disputes.number_of_disputes")
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "150",
                          prop: "disputeReason",
                          sortable: "",
                          label: _vm.$t("invoice-disputes.reason")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$translate.dispute_code(
                                        scope.row.disputeReason
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "150",
                          prop: "totalOpenAmount",
                          sortable: "",
                          label: _vm.$t("invoice-disputes.total_open_amount")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$formatter.toCurrency(
                                        scope.row.totalOpenAmount,
                                        scope.row.amount_currency
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "150",
                          prop: "oldestIssueDate",
                          sortable: "",
                          label: _vm.$t("invoice-disputes.issue_date")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("parseTime")(
                                        scope.row.oldestIssueDate,
                                        "{d}-{m}-{y}"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "150",
                          prop: "oldestDueDate",
                          sortable: "",
                          label: _vm.$t("invoice-disputes.oldest_due_date")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.oldestDueDate
                                  ? _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm._f("parseTime")(
                                              scope.row.oldestDueDate,
                                              "{d}-{m}-{y}"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  : _c("span", [_vm._v("-")])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "assignee.username",
                          sortable: "",
                          label: _vm.$t("invoice-disputes.assignee")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }